import { Routes } from '@angular/router';

import { WebsiteLayoutsComponent } from './website/layouts/website-layouts/website-layouts.component';
import { AuthLayoutComponent } from './portal/layouts/auth-layout/auth-layout.component';
import { AuthorizedGuard } from './portal/guards/authorized/authorized.guard';
import { StandardLayoutComponent } from './portal/layouts/standard-layout/standard-layout.component';
import { UnauthorizedGuard } from './portal/guards/unauthorized/unauthorized.guard';
import { StepguardGuard } from './portal/guards/stepguard/stepguard.guard';
import { StepAuthGuardGuard } from './portal/guards/stepAuthGuard/step-auth-guard.guard';
import { WebsiteCMSlayoutComponent } from './websiteCMS/website-cmslayout/website-cmslayout.component';
import { CompanyDetailsAccessGuard } from './portal/guards/company-details/company-details.guard';
import { CategoryGuard } from './portal/guards/category/category.guard';
import { AllformSubmitted } from './portal/guards/allform-submitted/allform-submitted.guard';

export const routes: Routes = [
  {
    path: '',
    component: WebsiteLayoutsComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./website/pages/home/home.module').then((h) => h.HomeModule),
      },
      {
        path: 'contact-us',
        loadChildren: () =>
          import('./website/pages/contact/contact.module').then(
            (c) => c.ContactModule,
          ),
      },
      {
        path: 'key-statistics',
        loadChildren: () =>
          import('./website/pages/keystat/keystat.module').then(
            (k) => k.keystatModule,
          ),
      },
      {
        path: 'about-us',
        loadChildren: () =>
          import('./website/pages/about/about.module').then(
            (a) => a.AboutModule,
          ),
      },
      {
        path: 'secretary-message',
        loadChildren: () =>
          import('./website/pages/directormsg/directormsg.module').then(
            (d) => d.Directormsg,
          ),
      },
      {
        path: 'vision-mission',
        loadChildren: () =>
          import('./website/pages/visionmission/directormsg.module').then(
            (v) => v.VisionMission,
          ),
      },
      {
        path: 'whoswho',
        loadChildren: () =>
          import('./website/pages/whoswho/whos.module').then((w) => w.WhosWho),
      },
      {
        path: 'policy',
        loadChildren: () =>
          import('./website/pages/policy/policy.module').then(
            (p) => p.policyModule,
          ),
      },
      {
        path: 'terms',
        loadChildren: () =>
          import('./website/pages/terms/terms.module').then(
            (t) => t.termsModule,
          ),
      },

      {
        path: 'copyright',
        loadChildren: () =>
          import('./website/pages/copyright/copyright.module').then(
            (co) => co.copyrightModule,
          ),
      },
      {
        path: 'hyperlinking',
        loadChildren: () =>
          import('./website/pages/hyperlinking/hyperlinking.module').then(
            (h) => h.hyperlinkingModule,
          ),
      },
      {
        path: 'accessibility',
        loadChildren: () =>
          import('./website/pages/accessibility/accessibility.module').then(
            (ac) => ac.accessibilityModule,
          ),
      },
      {
        path: 'faq',
        loadChildren: () =>
          import('./website/pages/faq/faq.module').then((f) => f.faqModule),
      },
      {
        path: 'feedback',
        loadChildren: () =>
          import('./website/pages/feedback/feedback.module').then(
            (fe) => fe.feedbackModule,
          ),
      },
    ],
  },
  {
    path: '',
    component: StandardLayoutComponent,
    canActivate: [AuthorizedGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./portal/pages/dashboard/dashboard.module').then(
            (d) => d.DashboardModule,
          ),
      },
      {
        path: 'update-profile',
        loadChildren: () =>
          import('./portal/pages/update-profile/update-profile.module').then(
            (u) => u.UpdateProfileModule,
          ),
      },
      {
        path: 'survey-response',
        loadChildren: () =>
          import('./portal/pages/survey-response/survey-response.module').then(
            (s) => s.SurveyResponseModule,
          ),
      },
      {
        path: 'submit-rd-needs',
        loadChildren: () =>
          import('./portal/pages/submit-rd-needs/submit-rd-needs.module').then(
            (s) => s.SubmitRdNeedsModule,
          ),
      },
      {
        path: 'apply-for-rating',
        loadChildren: () =>
          import(
            './portal/pages/apply-for-rating/apply-for-rating.module'
          ).then((a) => a.ApplyForRatingModule),
      },
      {
        path: 'feedbacks',
        loadChildren: () =>
          import('./portal/pages/feedback/feedback.module').then(
            (f) => f.FeedbackModule,
          ),
      },
      {
        path: 'queries',
        loadChildren: () =>
          import('./portal/pages/queries/queries.module').then(
            (q) => q.QueriesModule,
          ),
      },
    ],
  },
  {
    path: '',
    component: WebsiteCMSlayoutComponent,
    canActivate: [AuthorizedGuard],
    children: [
      {
        path: 'imporatntUpdate',
        loadChildren: () =>
          import(
            './websiteCMS/pages/important-update/imporant-update.module'
          ).then((d) => d.ImporantUpdateModule),
      },
      {
        path: 'upcomingEvents',
        loadChildren: () =>
          import('./websiteCMS/pages/events/events.module').then(
            (d) => d.EventsModule,
          ),
      },
      {
        path: 'latestnews',
        loadChildren: () =>
          import('./websiteCMS/pages/latest-news/latest-news.module').then(
            (d) => d.LatestNewsModule,
          ),
      },
      {
        path: 'herosection',
        loadChildren: () =>
          import('./websiteCMS/pages/hero-section/hero-section.module').then(
            (d) => d.HeroSectionModule,
          ),
      },
      {
        path: 'whoiswho',
        loadChildren: () =>
          import('./websiteCMS/pages/whos-who/whos-who.module').then(
            (d) => d.WhosWhoModule,
          ),
      },
      {
        path: 'externallink',
        loadChildren: () =>
          import('./websiteCMS/pages/external-link/external-link.module').then(
            (d) => d.ExternalLinkModule,
          ),
      },
      {
        path: 'gallerySection',
        loadChildren: () =>
          import('./websiteCMS/pages/gallery/gallery.module').then(
            (d) => d.GalleryModule,
          ),
      },
      {
        path: 'videoSection',
        loadChildren: () =>
          import('./websiteCMS/pages/video/video.module').then(
            (d) => d.VideoModule,
          ),
      },
    ],
  },
  {
    path: '',
    component: AuthLayoutComponent,
    canActivate: [UnauthorizedGuard],
    children: [
      {
        path: 'auth',
        loadChildren: () =>
          import('./portal/pages/auth/auth.module').then((a) => a.AuthModule),
      },
      {
        path: 'sso_auth',
        loadComponent: () =>
          import('./portal/callback/callback.component').then(
            (c) => c.CallbackComponent,
          ),
      },
      {
        path: 'login',
        loadChildren: () =>
          import('./portal/pages/login/login.module').then(
            (l) => l.LoginModule,
          ),
      },
      {
        path: 'verify',
        canActivate: [StepAuthGuardGuard],
        loadChildren: () =>
          import('./portal/pages/verify-otp/verify-otp.module').then(
            (v) => v.VerifyOtpModule,
          ),
      },
      {
        path: 'required-details',
        canActivate: [StepguardGuard],
        loadChildren: () =>
          import(
            './portal/pages/required-details/required-details.module'
          ).then((r) => r.RequiredDetailsModule),
      },
      {
        path: 'category',
        canActivate: [CategoryGuard],
        loadChildren: () =>
          import('./portal/pages/category/category.module').then(
            (c) => c.CategoryModule,
          ),
      },
      {
        path: 'category-main',
        canActivate: [CategoryGuard],
        loadChildren: () =>
          import('./portal/pages/main-category/main-category.module').then(
            (m) => m.MainCategoryModule,
          ),
      },
      {
        path: 'user-details',
        canActivate: [CompanyDetailsAccessGuard],
        loadChildren: () =>
          import('./portal/pages/user-details/user-details.module').then(
            (u) => u.UserDetailsModule,
          ),
      },
      {
        path: 'forgot-password',
        loadChildren: () =>
          import('./portal/pages/forgot-password/forgot-password.module').then(
            (f) => f.ForgotPasswordModule,
          ),
      },
      {
        path: 'reset-password',
        loadChildren: () =>
          import('./portal/pages/reset-password/reset-password.module').then(
            (r) => r.ResetPasswordModule,
          ),
      },
      {
        path: 'recyclers',
        canActivate: [AllformSubmitted],
        loadChildren: () =>
          import(
            './portal/pages/recycler-metal-details-form/recycler-metal-details-form.module'
          ).then((r) => r.RecyclerMetalDetailsFormModule),
      },
      {
        path: 'traders',
        canActivate: [AllformSubmitted],
        loadChildren: () =>
          import(
            './portal/pages/traders-metal-details-form/traders-metal-details-form.module'
          ).then((r) => r.TradersMetalDetailsFormModule),
      },
      {
        path: 'aggregators',
        canActivate: [AllformSubmitted],
        loadChildren: () =>
          import(
            './portal/pages/aggregators-metal-details-form/aggregators-metal-details-form.module'
          ).then((r) => r.AggregatorsMetalDetailsFormModule),
      },
      {
        path: 'dismantlers',
        canActivate: [AllformSubmitted],
        loadChildren: () =>
          import(
            './portal/pages/dismantlers-metal-details-form/dismantlers-metal-details-form.module'
          ).then((r) => r.DismantlersMetalDetailsFormModule),
      },
      {
        path: 'collection-centers',
        canActivate: [AllformSubmitted],
        loadChildren: () =>
          import(
            './portal/pages/collection-centres-metal-details-form/collection-centres-metal-details-form.module'
          ).then((r) => r.CollectionCentresMetalDetailsFormModule),
      },
      {
        path: 'associations',
        canActivate: [AllformSubmitted],
        loadChildren: () =>
          import(
            './portal/pages/associations-form/associations-form.module'
          ).then((a) => a.AssociationsFormModule),
      },
    ],
  },
  {
    path: 'server-error',
    loadComponent: () =>
      import('./portal/components/error-server/error-server.component').then(
        (e) => e.ErrorServerComponent,
      ),
  },
  {
    path: 'not-found',
    loadChildren: () =>
      import('./portal/pages/not-found/not-found.module').then(
        (n) => n.NotFoundModule,
      ),
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'not-found',
  },
];
